import request from "./request";

const CourseService = {
    GetIncidentsDashboard: async (context, signal) => {
        return await request.sendRequest(`/course/dashboard/incidents`, context.token, signal);
    },
    GetDashboard: async (context, signal) => {
        return await request.sendRequest(`/course/dashboard`, context.token, signal);
    },
    GetLearnersDashboard: async (context, signal) => {
        return await request.sendRequest(`/course/dashboard/learners`, context.token, signal);
    },
    GetRecentDashboard: async (context, signal) => {
        return await request.sendRequest(`/course/dashboard/recent`, context.token, signal);
    },
    GetCalenderChart: async (context, startDate, endDate, signal) => {
        return await request.sendRequest(`/dashboard/course/${startDate}/${endDate}`, context.token, signal);
    },
    GetAll: async (context, signal) => {
        return await request.sendRequest(`/course/all/courses`, context.token, signal );
    },
    GetFirmTypes: async (context, signal) => {
        return await request.sendRequest(`/course/all/firms`, context.token, signal);
    },
    GetCourses: async (context, signal) => {
        return await request.sendRequest(`/course/list/all`, context.token, signal);
    },
    GetCoursesByUser: async (context, signal) => {
        return await request.sendRequest(`/course/list/user`, context.token, signal);
    },
    Get: async (id, context, signal) => {
        return await request.sendRequest(`/course/${id}`, context.token, signal);
    },
    GetAttachments: async (id, searchText, context, signal) => {
        return await request.sendRequest(`/course/attachments/${id}/${searchText}`, context.token, signal);
    },
    GetIncidents: async (id, searchText, context, signal) => {
        return await request.sendRequest(`/course/incidents/${id}/${searchText}`, context.token, signal);
    },
    GetReleaseIncidents: async (id, searchText, context, signal) => {
        return await request.sendRequest(`/course/incidents/${id}/released/${searchText}`, context.token, signal);
    },
    GetMappedCourses: async (context, signal) => {
        return await request.sendRequest(`/vm/all/courses`, context.token, signal);
    },
    GetUsers: async (id, searchText, context, signal ) => {
        return await request.sendRequest(`/course/users/${id}/${searchText}`, context.token, signal);
    },
    GetCourseUsers: async (id, context, signal) => {
        return await request.sendRequest(`/course/mapped/users/${id}`, context.token, signal);
    },
    GetUserCourses: async (id, context, signal) => {
        return await request.sendRequest(`/course/user/${id}`, context.token, signal);
    },
    GetClients: async (context, signal) => {
        return await request.sendRequest(`/course/clients`, context.token, signal);
    },
    GetUserVMs: async (id, context, signal) => {
        return await request.sendRequest(`/vm/all/${id}`, context.token, signal);
    },
    GetFile: async (id, context, signal) => {
        return await request.sendRequest(`/course/file/${id}`, context.token, signal);
    },
    SaveUserVM: async (payload, context, signal) => {
        return await request.sendPostRequest(`/vm`, payload, context, signal);
    },
    ImportUserVM: async (id, payload, context, signal) => {
        return await request.sendFormDataRequest(`/vm/import/${id}`, payload, context, signal);
    },
    ImportUserGVM: async (id, payload, context, signal) => {
        return await request.sendFormDataRequest(`/vm/import/${id}/guacamole`, payload, context, signal);
    },
    Save: async (payload, context, signal) => {
        return await request.sendPostRequest(`/course`, payload, context, signal);
    },
    SaveIncidents: async (payload, context, signal) => {
        return await request.sendPostRequest(`/course/incidents`, payload, context, signal);
    },
    SaveReleaseIncidents: async (payload, context, signal) => {
        return await request.sendPostRequest(`/course/incidents/release`, payload, context, signal);
    },
    SaveUsers: async (payload, context, signal) => {
        return await request.sendPostRequest(`/course/users`, payload, context, signal);
    },
    SaveUser: async (payload, context, signal) => {
        return await request.sendPostRequest(`/course/user`, payload, context, signal);
    },
    SaveAttachment: async (payload, context, signal) => {
        return await request.sendPostRequest(`/course/attachments`, payload, context, signal);
    },
    Remove: async (id, context) => {
        return await request.sendDeleteRequest(`/course/${id}`, context.token);
    },
    RemoveUserVM: async (id, context) => {
        return await request.sendDeleteRequest(`/vm/${id}`, context.token);
    },
};

export default CourseService;
